/* ============================================================
   Elara Theme — theme.js
   Scroll reveal · Quick add to cart · Smooth interactions
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Scroll Reveal ──────────────────────────────────────── */
  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );

  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));


  /* ── Quick Add to Cart ──────────────────────────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-variant-id]');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.textContent = 'Aggiunta…';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      });

      if (!res.ok) throw new Error('Cart error');

      btn.textContent = '✓ Aggiunto!';
      btn.style.background = 'var(--color-dusty-rose)';

      // Update cart count
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      const countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }

      setTimeout(() => {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 2000);

    } catch (err) {
      btn.textContent = 'Errore';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 2000);
    }
  });


  /* ── Wishlist Toggle (UI only — connect to app for persistence) ── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.product-card__wishlist');
    if (!btn) return;

    btn.classList.toggle('wishlisted');
    const svg = btn.querySelector('svg');
    if (btn.classList.contains('wishlisted')) {
      svg.style.fill = 'var(--color-dusty-rose)';
      svg.style.stroke = 'var(--color-dusty-rose)';
      btn.setAttribute('aria-label', 'Rimuovi dai desideri');
    } else {
      svg.style.fill = 'none';
      svg.style.stroke = 'currentColor';
      btn.setAttribute('aria-label', 'Aggiungi ai desideri');
    }
  });


  /* ── Search Overlay (basic) ─────────────────────────────── */
  const searchToggle = document.getElementById('search-toggle');
  if (searchToggle) {
    searchToggle.addEventListener('click', () => {
      // Extend with a full search overlay component as needed
      const query = prompt('Cerca nel negozio…');
      if (query && query.trim()) {
        window.location.href = `/search?q=${encodeURIComponent(query.trim())}`;
      }
    });
  }


  /* ── Smooth hover on product cards ─────────────────────── */
  // CSS handles most transitions — JS used only for progressive enhancement


  /* ── Newsletter form feedback ───────────────────────────── */
  const newsletterForm = document.getElementById('elara-newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', (e) => {
      const submitBtn = newsletterForm.querySelector('.newsletter__submit');
      if (submitBtn) {
        submitBtn.textContent = 'Iscrizione in corso…';
        submitBtn.disabled = true;
        // Shopify handles the actual form submission
        setTimeout(() => {
          submitBtn.textContent = 'Iscritto! ✓';
          submitBtn.style.background = 'var(--color-dusty-rose)';
        }, 800);
      }
    });
  }


  /* ── Mobile menu hamburger animation ───────────────────── */
  const toggle = document.getElementById('mobile-nav-toggle');
  const mobileNav = document.getElementById('mobile-nav');

  if (toggle && mobileNav) {
    const spans = toggle.querySelectorAll('span');

    const observer = new MutationObserver(() => {
      const isOpen = mobileNav.classList.contains('open');
      if (isOpen) {
        spans[0].style.transform = 'rotate(45deg) translate(4.5px, 4.5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(4.5px, -4.5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });

    observer.observe(mobileNav, { attributes: true, attributeFilter: ['class'] });
  }


  /* ── Lazy loading fallback ──────────────────────────────── */
  if ('loading' in HTMLImageElement.prototype === false) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const imgObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src || img.src;
          imgObserver.unobserve(img);
        }
      });
    });
    lazyImages.forEach(img => imgObserver.observe(img));
  }

});
